export enum AuthenticationMethod {
  microsoft = 'microsoft',
  password = 'password',
}
